import React from 'react';
import { StyledTitle } from './styled';

const Title = ({ title }) => {
  return (
    <StyledTitle>
      <div>{title}</div>
    </StyledTitle>);
}

export default Title;
